import { observer } from 'mobx-react-lite'
import { Alert, Typography } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { PriceInfo } from 'entities/Billing'
import { getBillingLabel } from 'entities/Billing/lib/billingInterval'
import { type AddOnModalStore } from 'pages/settings/ui/AddOnModal/store/addOnModalStore'
import styles from './styles.module.scss'

type IContentSecondStepProps = {
  store: AddOnModalStore
}

export const ContentSecondStep = observer(({ store }: IContentSecondStepProps) => {
  const { isPaymentError, priceInfoStore } = store
  const { priceInfoUiData } = priceInfoStore

  const trustedCallingTitle = priceInfoUiData ? (
    <TitledRow
      title={'Trusted Calling'}
      titleProps={{ color: 'var(--content-primary-primary)', variant: 'body-md-regular' }}
    >
      <Typography ariaLabel={'TierPrice'} variant={'body-md-regular'}>
        {`${priceInfoUiData.subtotal} / ${getBillingLabel(priceInfoUiData.interval)}`}
      </Typography>
    </TitledRow>
  ) : null

  return (
    <div>
      <div className={styles.header}>
        <Typography ariaLabel='trustedCalling' variant='heading-lg'>
          Trusted Calling
        </Typography>
      </div>

      {isPaymentError && (
        <Alert
          className={styles.paymentErrorAlert}
          marginBottom={24}
          item={{
            type: 'error',
            title: 'We were unable to process your payment',
            desc: 'Please select a different card',
          }}
        />
      )}

      <PriceInfo priceInfoStore={priceInfoStore} title={trustedCallingTitle} />
    </div>
  )
})
